<template>
  <div class="week-selector">
    <b-field label="Semana" label-position="inside">
      <p class="control">
        <b-button class="button is-primary btn-left" @click="subtractWeek">Anterior</b-button>
      </p>
      <b-datepicker
            placeholder="Selecciona una semana"
            v-model="dates"
            :first-day-of-week="1"
            :month-names="$moment.months()"
            :day-names="$moment.weekdaysShort()"
            :show-week-number="true"
            :unselectable-days-of-week="[0]"
            position="is-bottom-left"
            :mobile-native="false"
            range expanded>
      </b-datepicker>
      <p class="control">
        <b-button class="button is-primary" @click="addWeek">Siguiente</b-button>
      </p>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    start: {
      type: Date,
      required: false
    },
    finish: {
      type: Date,
      required: false
    }
  },
  created () {
    if (this.start) {
      this.dates[0] = this.$moment(this.start).weekday(0).toDate()
    } else {
      this.dates[0] = this.$moment().weekday(0).toDate()
    }
    if (this.finish) {
      this.dates[1] = this.$moment(this.finish).weekday(5).toDate()
    } else {
      this.dates[1] = this.$moment().weekday(5).toDate()
    }
  },
  data () {
    return {
      dates: []
    }
  },
  methods: {
    subtractWeek () {
      let dateRange = []
      dateRange[0] = this.$moment(this.dates[0]).subtract(1, 'weeks').toDate()
      dateRange[1] = this.$moment(this.dates[1]).subtract(1, 'weeks').toDate()
      this.dates = dateRange
    },
    addWeek () {
      let dateRange = []
      dateRange[0] = this.$moment(this.dates[0]).add(1, 'weeks').toDate()
      dateRange[1] = this.$moment(this.dates[1]).add(1, 'weeks').toDate()
      this.dates = dateRange
    }
  },
  watch: {
    dates () {
      this.$emit('change', this.dates)
      this.$emit('update:start', this.dates[0])
      this.$emit('update:finish', this.dates[1])
    },
    start (value) {
      if (value) {
        this.dates[0] = this.$moment(value).weekday(0).toDate()
      }
    },
    finish (value) {
      if (value) {
        this.dates[1] = this.$moment(value).weekday(5).toDate()
      }
    }
  }

}
</script>

<style>
  .week-selector label.label {
    margin-left: 80px !important;
  }
  .week-selector button.btn-left {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }
  .week-selector select{
    height: 32.48px !important;
  }
</style>
